@file:OptIn(InternalResourceApi::class)

package advancedmpkeditor.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/advancedmpkeditor.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_408_136_604)
internal val Res.drawable.elder_guardian_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:elder_guardian_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/elder_guardian_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_092_281_199)
internal val Res.drawable.elytra: DrawableResource by lazy {
      DrawableResource("drawable:elytra", setOf(
        ResourceItem(setOf(), "${MD}drawable/elytra.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(22_329_897)
internal val Res.drawable.emerald: DrawableResource by lazy {
      DrawableResource("drawable:emerald", setOf(
        ResourceItem(setOf(), "${MD}drawable/emerald.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_641_371_975)
internal val Res.drawable.emerald_block: DrawableResource by lazy {
      DrawableResource("drawable:emerald_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/emerald_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_043_762_275)
internal val Res.drawable.emerald_ore: DrawableResource by lazy {
      DrawableResource("drawable:emerald_ore", setOf(
        ResourceItem(setOf(), "${MD}drawable/emerald_ore.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(78_016_518)
internal val Res.drawable.empty_boots_slot: DrawableResource by lazy {
      DrawableResource("drawable:empty_boots_slot", setOf(
        ResourceItem(setOf(), "${MD}drawable/empty_boots_slot.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(717_886_045)
internal val Res.drawable.empty_chestplate_slot: DrawableResource by lazy {
      DrawableResource("drawable:empty_chestplate_slot", setOf(
        ResourceItem(setOf(), "${MD}drawable/empty_chestplate_slot.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_696_625_404)
internal val Res.drawable.empty_helmet_slot: DrawableResource by lazy {
      DrawableResource("drawable:empty_helmet_slot", setOf(
        ResourceItem(setOf(), "${MD}drawable/empty_helmet_slot.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_347_012_093)
internal val Res.drawable.empty_leggings_slot: DrawableResource by lazy {
      DrawableResource("drawable:empty_leggings_slot", setOf(
        ResourceItem(setOf(), "${MD}drawable/empty_leggings_slot.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_696_373_434)
internal val Res.drawable.enchanted_book: DrawableResource by lazy {
      DrawableResource("drawable:enchanted_book", setOf(
        ResourceItem(setOf(), "${MD}drawable/enchanted_book.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_988_693_156)
internal val Res.drawable.enchanted_golden_apple: DrawableResource by lazy {
      DrawableResource("drawable:enchanted_golden_apple", setOf(
        ResourceItem(setOf(), "${MD}drawable/enchanted_golden_apple.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_202_357_860)
internal val Res.drawable.enchanting_table: DrawableResource by lazy {
      DrawableResource("drawable:enchanting_table", setOf(
        ResourceItem(setOf(), "${MD}drawable/enchanting_table.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_249_958_058)
internal val Res.drawable.end_crystal: DrawableResource by lazy {
      DrawableResource("drawable:end_crystal", setOf(
        ResourceItem(setOf(), "${MD}drawable/end_crystal.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_572_203_386)
internal val Res.drawable.end_portal_frame: DrawableResource by lazy {
      DrawableResource("drawable:end_portal_frame", setOf(
        ResourceItem(setOf(), "${MD}drawable/end_portal_frame.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(537_344_114)
internal val Res.drawable.end_rod: DrawableResource by lazy {
      DrawableResource("drawable:end_rod", setOf(
        ResourceItem(setOf(), "${MD}drawable/end_rod.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_024_345_565)
internal val Res.drawable.end_stone: DrawableResource by lazy {
      DrawableResource("drawable:end_stone", setOf(
        ResourceItem(setOf(), "${MD}drawable/end_stone.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_426_626_871)
internal val Res.drawable.end_stone_brick_slab: DrawableResource by lazy {
      DrawableResource("drawable:end_stone_brick_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/end_stone_brick_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_850_210_813)
internal val Res.drawable.end_stone_brick_stairs: DrawableResource by lazy {
      DrawableResource("drawable:end_stone_brick_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/end_stone_brick_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-635_842_700)
internal val Res.drawable.end_stone_brick_wall: DrawableResource by lazy {
      DrawableResource("drawable:end_stone_brick_wall", setOf(
        ResourceItem(setOf(), "${MD}drawable/end_stone_brick_wall.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_152_688_673)
internal val Res.drawable.end_stone_bricks: DrawableResource by lazy {
      DrawableResource("drawable:end_stone_bricks", setOf(
        ResourceItem(setOf(), "${MD}drawable/end_stone_bricks.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-174_099_031)
internal val Res.drawable.ender_chest: DrawableResource by lazy {
      DrawableResource("drawable:ender_chest", setOf(
        ResourceItem(setOf(), "${MD}drawable/ender_chest.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-393_247_288)
internal val Res.drawable.ender_eye: DrawableResource by lazy {
      DrawableResource("drawable:ender_eye", setOf(
        ResourceItem(setOf(), "${MD}drawable/ender_eye.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(70_744_995)
internal val Res.drawable.ender_pearl: DrawableResource by lazy {
      DrawableResource("drawable:ender_pearl", setOf(
        ResourceItem(setOf(), "${MD}drawable/ender_pearl.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(251_782_062)
internal val Res.drawable.enderman_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:enderman_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/enderman_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-951_481_334)
internal val Res.drawable.endermite_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:endermite_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/endermite_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_391_070_657)
internal val Res.drawable.evoker_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:evoker_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/evoker_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_692_896_843)
internal val Res.drawable.experience_bottle: DrawableResource by lazy {
      DrawableResource("drawable:experience_bottle", setOf(
        ResourceItem(setOf(), "${MD}drawable/experience_bottle.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(294_915_791)
internal val Res.drawable.farmland: DrawableResource by lazy {
      DrawableResource("drawable:farmland", setOf(
        ResourceItem(setOf(), "${MD}drawable/farmland.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_507_842_798)
internal val Res.drawable.feather: DrawableResource by lazy {
      DrawableResource("drawable:feather", setOf(
        ResourceItem(setOf(), "${MD}drawable/feather.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_505_178_053)
internal val Res.drawable.fermented_spider_eye: DrawableResource by lazy {
      DrawableResource("drawable:fermented_spider_eye", setOf(
        ResourceItem(setOf(), "${MD}drawable/fermented_spider_eye.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(913_212_336)
internal val Res.drawable.fern: DrawableResource by lazy {
      DrawableResource("drawable:fern", setOf(
        ResourceItem(setOf(), "${MD}drawable/fern.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_023_496_309)
internal val Res.drawable.filled_map: DrawableResource by lazy {
      DrawableResource("drawable:filled_map", setOf(
        ResourceItem(setOf(), "${MD}drawable/filled_map.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(797_966_704)
internal val Res.drawable.fire_charge: DrawableResource by lazy {
      DrawableResource("drawable:fire_charge", setOf(
        ResourceItem(setOf(), "${MD}drawable/fire_charge.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_897_433_711)
internal val Res.drawable.fire_coral: DrawableResource by lazy {
      DrawableResource("drawable:fire_coral", setOf(
        ResourceItem(setOf(), "${MD}drawable/fire_coral.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_352_745_092)
internal val Res.drawable.fire_coral_block: DrawableResource by lazy {
      DrawableResource("drawable:fire_coral_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/fire_coral_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(160_912_035)
internal val Res.drawable.fire_coral_fan: DrawableResource by lazy {
      DrawableResource("drawable:fire_coral_fan", setOf(
        ResourceItem(setOf(), "${MD}drawable/fire_coral_fan.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_295_075_612)
internal val Res.drawable.fire_res: DrawableResource by lazy {
      DrawableResource("drawable:fire_res", setOf(
        ResourceItem(setOf(), "${MD}drawable/fire_res.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_984_803_160)
internal val Res.drawable.firework_rocket: DrawableResource by lazy {
      DrawableResource("drawable:firework_rocket", setOf(
        ResourceItem(setOf(), "${MD}drawable/firework_rocket.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_969_564_411)
internal val Res.drawable.firework_star: DrawableResource by lazy {
      DrawableResource("drawable:firework_star", setOf(
        ResourceItem(setOf(), "${MD}drawable/firework_star.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_203_080_292)
internal val Res.drawable.fishing_rod: DrawableResource by lazy {
      DrawableResource("drawable:fishing_rod", setOf(
        ResourceItem(setOf(), "${MD}drawable/fishing_rod.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-850_244_102)
internal val Res.drawable.fletching_table: DrawableResource by lazy {
      DrawableResource("drawable:fletching_table", setOf(
        ResourceItem(setOf(), "${MD}drawable/fletching_table.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_663_980_709)
internal val Res.drawable.flint: DrawableResource by lazy {
      DrawableResource("drawable:flint", setOf(
        ResourceItem(setOf(), "${MD}drawable/flint.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_814_142_043)
internal val Res.drawable.flint_and_steel: DrawableResource by lazy {
      DrawableResource("drawable:flint_and_steel", setOf(
        ResourceItem(setOf(), "${MD}drawable/flint_and_steel.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(602_574_756)
internal val Res.drawable.flower_banner_pattern: DrawableResource by lazy {
      DrawableResource("drawable:flower_banner_pattern", setOf(
        ResourceItem(setOf(), "${MD}drawable/flower_banner_pattern.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-957_564_676)
internal val Res.drawable.flower_pot: DrawableResource by lazy {
      DrawableResource("drawable:flower_pot", setOf(
        ResourceItem(setOf(), "${MD}drawable/flower_pot.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_209_946_245)
internal val Res.drawable.force_perch_potion: DrawableResource by lazy {
      DrawableResource("drawable:force_perch_potion", setOf(
        ResourceItem(setOf(), "${MD}drawable/force_perch_potion.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_651_612_936)
internal val Res.drawable.fox_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:fox_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/fox_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-105_812_265)
internal val Res.drawable.furnace: DrawableResource by lazy {
      DrawableResource("drawable:furnace", setOf(
        ResourceItem(setOf(), "${MD}drawable/furnace.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-492_741_834)
internal val Res.drawable.furnace_minecart: DrawableResource by lazy {
      DrawableResource("drawable:furnace_minecart", setOf(
        ResourceItem(setOf(), "${MD}drawable/furnace_minecart.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_796_650_460)
internal val Res.drawable.ghast_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:ghast_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/ghast_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_158_293_827)
internal val Res.drawable.ghast_tear: DrawableResource by lazy {
      DrawableResource("drawable:ghast_tear", setOf(
        ResourceItem(setOf(), "${MD}drawable/ghast_tear.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_385_510_481)
internal val Res.drawable.gilded_blackstone: DrawableResource by lazy {
      DrawableResource("drawable:gilded_blackstone", setOf(
        ResourceItem(setOf(), "${MD}drawable/gilded_blackstone.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(121_210_394)
internal val Res.drawable.glass: DrawableResource by lazy {
      DrawableResource("drawable:glass", setOf(
        ResourceItem(setOf(), "${MD}drawable/glass.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_192_444_242)
internal val Res.drawable.glass_bottle: DrawableResource by lazy {
      DrawableResource("drawable:glass_bottle", setOf(
        ResourceItem(setOf(), "${MD}drawable/glass_bottle.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_260_460_413)
internal val Res.drawable.glass_pane: DrawableResource by lazy {
      DrawableResource("drawable:glass_pane", setOf(
        ResourceItem(setOf(), "${MD}drawable/glass_pane.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(177_529_200)
internal val Res.drawable.glistering_melon_slice: DrawableResource by lazy {
      DrawableResource("drawable:glistering_melon_slice", setOf(
        ResourceItem(setOf(), "${MD}drawable/glistering_melon_slice.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(602_574_756)
internal val Res.drawable.globe_banner_pattern: DrawableResource by lazy {
      DrawableResource("drawable:globe_banner_pattern", setOf(
        ResourceItem(setOf(), "${MD}drawable/globe_banner_pattern.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_495_719_990)
internal val Res.drawable.glowstone: DrawableResource by lazy {
      DrawableResource("drawable:glowstone", setOf(
        ResourceItem(setOf(), "${MD}drawable/glowstone.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_462_181_126)
internal val Res.drawable.glowstone_dust: DrawableResource by lazy {
      DrawableResource("drawable:glowstone_dust", setOf(
        ResourceItem(setOf(), "${MD}drawable/glowstone_dust.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(777_921_003)
internal val Res.drawable.gold_block: DrawableResource by lazy {
      DrawableResource("drawable:gold_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/gold_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-930_600_535)
internal val Res.drawable.gold_ingot: DrawableResource by lazy {
      DrawableResource("drawable:gold_ingot", setOf(
        ResourceItem(setOf(), "${MD}drawable/gold_ingot.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(572_003_280)
internal val Res.drawable.gold_nugget: DrawableResource by lazy {
      DrawableResource("drawable:gold_nugget", setOf(
        ResourceItem(setOf(), "${MD}drawable/gold_nugget.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_887_856_105)
internal val Res.drawable.gold_ore: DrawableResource by lazy {
      DrawableResource("drawable:gold_ore", setOf(
        ResourceItem(setOf(), "${MD}drawable/gold_ore.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-727_238_476)
internal val Res.drawable.golden_apple: DrawableResource by lazy {
      DrawableResource("drawable:golden_apple", setOf(
        ResourceItem(setOf(), "${MD}drawable/golden_apple.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-830_481_072)
internal val Res.drawable.golden_axe: DrawableResource by lazy {
      DrawableResource("drawable:golden_axe", setOf(
        ResourceItem(setOf(), "${MD}drawable/golden_axe.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_554_201_650)
internal val Res.drawable.golden_boots: DrawableResource by lazy {
      DrawableResource("drawable:golden_boots", setOf(
        ResourceItem(setOf(), "${MD}drawable/golden_boots.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(618_617_324)
internal val Res.drawable.golden_boots_ss1: DrawableResource by lazy {
      DrawableResource("drawable:golden_boots_ss1", setOf(
        ResourceItem(setOf(), "${MD}drawable/golden_boots_ss1.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_214_984_992)
internal val Res.drawable.golden_boots_ss2: DrawableResource by lazy {
      DrawableResource("drawable:golden_boots_ss2", setOf(
        ResourceItem(setOf(), "${MD}drawable/golden_boots_ss2.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_873_015_148)
internal val Res.drawable.golden_boots_ss3: DrawableResource by lazy {
      DrawableResource("drawable:golden_boots_ss3", setOf(
        ResourceItem(setOf(), "${MD}drawable/golden_boots_ss3.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_966_116_155)
internal val Res.drawable.golden_carrot: DrawableResource by lazy {
      DrawableResource("drawable:golden_carrot", setOf(
        ResourceItem(setOf(), "${MD}drawable/golden_carrot.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_763_555_953)
internal val Res.drawable.golden_chestplate: DrawableResource by lazy {
      DrawableResource("drawable:golden_chestplate", setOf(
        ResourceItem(setOf(), "${MD}drawable/golden_chestplate.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(133_144_267)
internal val Res.drawable.golden_helmet: DrawableResource by lazy {
      DrawableResource("drawable:golden_helmet", setOf(
        ResourceItem(setOf(), "${MD}drawable/golden_helmet.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-528_890_852)
internal val Res.drawable.golden_hoe: DrawableResource by lazy {
      DrawableResource("drawable:golden_hoe", setOf(
        ResourceItem(setOf(), "${MD}drawable/golden_hoe.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(302_516_352)
internal val Res.drawable.golden_horse_armor: DrawableResource by lazy {
      DrawableResource("drawable:golden_horse_armor", setOf(
        ResourceItem(setOf(), "${MD}drawable/golden_horse_armor.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(545_484_046)
internal val Res.drawable.golden_leggings: DrawableResource by lazy {
      DrawableResource("drawable:golden_leggings", setOf(
        ResourceItem(setOf(), "${MD}drawable/golden_leggings.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-224_390_438)
internal val Res.drawable.golden_pickaxe: DrawableResource by lazy {
      DrawableResource("drawable:golden_pickaxe", setOf(
        ResourceItem(setOf(), "${MD}drawable/golden_pickaxe.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_734_939_599)
internal val Res.drawable.golden_shovel: DrawableResource by lazy {
      DrawableResource("drawable:golden_shovel", setOf(
        ResourceItem(setOf(), "${MD}drawable/golden_shovel.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_115_909_813)
internal val Res.drawable.golden_sword: DrawableResource by lazy {
      DrawableResource("drawable:golden_sword", setOf(
        ResourceItem(setOf(), "${MD}drawable/golden_sword.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_036_559_805)
internal val Res.drawable.golden_sword_l1: DrawableResource by lazy {
      DrawableResource("drawable:golden_sword_l1", setOf(
        ResourceItem(setOf(), "${MD}drawable/golden_sword_l1.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(684_511_816)
internal val Res.drawable.golden_sword_l2: DrawableResource by lazy {
      DrawableResource("drawable:golden_sword_l2", setOf(
        ResourceItem(setOf(), "${MD}drawable/golden_sword_l2.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-829_394_859)
internal val Res.drawable.golden_sword_l3: DrawableResource by lazy {
      DrawableResource("drawable:golden_sword_l3", setOf(
        ResourceItem(setOf(), "${MD}drawable/golden_sword_l3.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_900_913_176)
internal val Res.drawable.granite: DrawableResource by lazy {
      DrawableResource("drawable:granite", setOf(
        ResourceItem(setOf(), "${MD}drawable/granite.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_143_489_816)
internal val Res.drawable.granite_slab: DrawableResource by lazy {
      DrawableResource("drawable:granite_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/granite_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_191_622_339)
internal val Res.drawable.granite_stairs: DrawableResource by lazy {
      DrawableResource("drawable:granite_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/granite_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_722_646_946)
internal val Res.drawable.granite_wall: DrawableResource by lazy {
      DrawableResource("drawable:granite_wall", setOf(
        ResourceItem(setOf(), "${MD}drawable/granite_wall.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_018_662_362)
internal val Res.drawable.grass: DrawableResource by lazy {
      DrawableResource("drawable:grass", setOf(
        ResourceItem(setOf(), "${MD}drawable/grass.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(549_045_258)
internal val Res.drawable.grass_block: DrawableResource by lazy {
      DrawableResource("drawable:grass_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/grass_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_058_737_727)
internal val Res.drawable.grass_path: DrawableResource by lazy {
      DrawableResource("drawable:grass_path", setOf(
        ResourceItem(setOf(), "${MD}drawable/grass_path.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_746_100_504)
internal val Res.drawable.gravel: DrawableResource by lazy {
      DrawableResource("drawable:gravel", setOf(
        ResourceItem(setOf(), "${MD}drawable/gravel.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(923_974_929)
internal val Res.drawable.gray_banner: DrawableResource by lazy {
      DrawableResource("drawable:gray_banner", setOf(
        ResourceItem(setOf(), "${MD}drawable/gray_banner.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_454_883)
internal val Res.drawable.gray_bed: DrawableResource by lazy {
      DrawableResource("drawable:gray_bed", setOf(
        ResourceItem(setOf(), "${MD}drawable/gray_bed.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(244_868_527)
internal val Res.drawable.gray_carpet: DrawableResource by lazy {
      DrawableResource("drawable:gray_carpet", setOf(
        ResourceItem(setOf(), "${MD}drawable/gray_carpet.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-765_123_615)
internal val Res.drawable.gray_concrete: DrawableResource by lazy {
      DrawableResource("drawable:gray_concrete", setOf(
        ResourceItem(setOf(), "${MD}drawable/gray_concrete.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_367_794_031)
internal val Res.drawable.gray_concrete_powder: DrawableResource by lazy {
      DrawableResource("drawable:gray_concrete_powder", setOf(
        ResourceItem(setOf(), "${MD}drawable/gray_concrete_powder.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(67_342_779)
internal val Res.drawable.gray_dye: DrawableResource by lazy {
      DrawableResource("drawable:gray_dye", setOf(
        ResourceItem(setOf(), "${MD}drawable/gray_dye.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(647_631_119)
internal val Res.drawable.gray_glazed_terracotta: DrawableResource by lazy {
      DrawableResource("drawable:gray_glazed_terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/gray_glazed_terracotta.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-349_312_299)
internal val Res.drawable.gray_shulker_box: DrawableResource by lazy {
      DrawableResource("drawable:gray_shulker_box", setOf(
        ResourceItem(setOf(), "${MD}drawable/gray_shulker_box.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_202_913_522)
internal val Res.drawable.gray_stained_glass: DrawableResource by lazy {
      DrawableResource("drawable:gray_stained_glass", setOf(
        ResourceItem(setOf(), "${MD}drawable/gray_stained_glass.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_132_439_525)
internal val Res.drawable.gray_stained_glass_pane: DrawableResource by lazy {
      DrawableResource("drawable:gray_stained_glass_pane", setOf(
        ResourceItem(setOf(), "${MD}drawable/gray_stained_glass_pane.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_168_740_159)
internal val Res.drawable.gray_terracotta: DrawableResource by lazy {
      DrawableResource("drawable:gray_terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/gray_terracotta.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable3Resources(map: MutableMap<String, DrawableResource>) {
  map.put("elder_guardian_spawn_egg", Res.drawable.elder_guardian_spawn_egg)
  map.put("elytra", Res.drawable.elytra)
  map.put("emerald", Res.drawable.emerald)
  map.put("emerald_block", Res.drawable.emerald_block)
  map.put("emerald_ore", Res.drawable.emerald_ore)
  map.put("empty_boots_slot", Res.drawable.empty_boots_slot)
  map.put("empty_chestplate_slot", Res.drawable.empty_chestplate_slot)
  map.put("empty_helmet_slot", Res.drawable.empty_helmet_slot)
  map.put("empty_leggings_slot", Res.drawable.empty_leggings_slot)
  map.put("enchanted_book", Res.drawable.enchanted_book)
  map.put("enchanted_golden_apple", Res.drawable.enchanted_golden_apple)
  map.put("enchanting_table", Res.drawable.enchanting_table)
  map.put("end_crystal", Res.drawable.end_crystal)
  map.put("end_portal_frame", Res.drawable.end_portal_frame)
  map.put("end_rod", Res.drawable.end_rod)
  map.put("end_stone", Res.drawable.end_stone)
  map.put("end_stone_brick_slab", Res.drawable.end_stone_brick_slab)
  map.put("end_stone_brick_stairs", Res.drawable.end_stone_brick_stairs)
  map.put("end_stone_brick_wall", Res.drawable.end_stone_brick_wall)
  map.put("end_stone_bricks", Res.drawable.end_stone_bricks)
  map.put("ender_chest", Res.drawable.ender_chest)
  map.put("ender_eye", Res.drawable.ender_eye)
  map.put("ender_pearl", Res.drawable.ender_pearl)
  map.put("enderman_spawn_egg", Res.drawable.enderman_spawn_egg)
  map.put("endermite_spawn_egg", Res.drawable.endermite_spawn_egg)
  map.put("evoker_spawn_egg", Res.drawable.evoker_spawn_egg)
  map.put("experience_bottle", Res.drawable.experience_bottle)
  map.put("farmland", Res.drawable.farmland)
  map.put("feather", Res.drawable.feather)
  map.put("fermented_spider_eye", Res.drawable.fermented_spider_eye)
  map.put("fern", Res.drawable.fern)
  map.put("filled_map", Res.drawable.filled_map)
  map.put("fire_charge", Res.drawable.fire_charge)
  map.put("fire_coral", Res.drawable.fire_coral)
  map.put("fire_coral_block", Res.drawable.fire_coral_block)
  map.put("fire_coral_fan", Res.drawable.fire_coral_fan)
  map.put("fire_res", Res.drawable.fire_res)
  map.put("firework_rocket", Res.drawable.firework_rocket)
  map.put("firework_star", Res.drawable.firework_star)
  map.put("fishing_rod", Res.drawable.fishing_rod)
  map.put("fletching_table", Res.drawable.fletching_table)
  map.put("flint", Res.drawable.flint)
  map.put("flint_and_steel", Res.drawable.flint_and_steel)
  map.put("flower_banner_pattern", Res.drawable.flower_banner_pattern)
  map.put("flower_pot", Res.drawable.flower_pot)
  map.put("force_perch_potion", Res.drawable.force_perch_potion)
  map.put("fox_spawn_egg", Res.drawable.fox_spawn_egg)
  map.put("furnace", Res.drawable.furnace)
  map.put("furnace_minecart", Res.drawable.furnace_minecart)
  map.put("ghast_spawn_egg", Res.drawable.ghast_spawn_egg)
  map.put("ghast_tear", Res.drawable.ghast_tear)
  map.put("gilded_blackstone", Res.drawable.gilded_blackstone)
  map.put("glass", Res.drawable.glass)
  map.put("glass_bottle", Res.drawable.glass_bottle)
  map.put("glass_pane", Res.drawable.glass_pane)
  map.put("glistering_melon_slice", Res.drawable.glistering_melon_slice)
  map.put("globe_banner_pattern", Res.drawable.globe_banner_pattern)
  map.put("glowstone", Res.drawable.glowstone)
  map.put("glowstone_dust", Res.drawable.glowstone_dust)
  map.put("gold_block", Res.drawable.gold_block)
  map.put("gold_ingot", Res.drawable.gold_ingot)
  map.put("gold_nugget", Res.drawable.gold_nugget)
  map.put("gold_ore", Res.drawable.gold_ore)
  map.put("golden_apple", Res.drawable.golden_apple)
  map.put("golden_axe", Res.drawable.golden_axe)
  map.put("golden_boots", Res.drawable.golden_boots)
  map.put("golden_boots_ss1", Res.drawable.golden_boots_ss1)
  map.put("golden_boots_ss2", Res.drawable.golden_boots_ss2)
  map.put("golden_boots_ss3", Res.drawable.golden_boots_ss3)
  map.put("golden_carrot", Res.drawable.golden_carrot)
  map.put("golden_chestplate", Res.drawable.golden_chestplate)
  map.put("golden_helmet", Res.drawable.golden_helmet)
  map.put("golden_hoe", Res.drawable.golden_hoe)
  map.put("golden_horse_armor", Res.drawable.golden_horse_armor)
  map.put("golden_leggings", Res.drawable.golden_leggings)
  map.put("golden_pickaxe", Res.drawable.golden_pickaxe)
  map.put("golden_shovel", Res.drawable.golden_shovel)
  map.put("golden_sword", Res.drawable.golden_sword)
  map.put("golden_sword_l1", Res.drawable.golden_sword_l1)
  map.put("golden_sword_l2", Res.drawable.golden_sword_l2)
  map.put("golden_sword_l3", Res.drawable.golden_sword_l3)
  map.put("granite", Res.drawable.granite)
  map.put("granite_slab", Res.drawable.granite_slab)
  map.put("granite_stairs", Res.drawable.granite_stairs)
  map.put("granite_wall", Res.drawable.granite_wall)
  map.put("grass", Res.drawable.grass)
  map.put("grass_block", Res.drawable.grass_block)
  map.put("grass_path", Res.drawable.grass_path)
  map.put("gravel", Res.drawable.gravel)
  map.put("gray_banner", Res.drawable.gray_banner)
  map.put("gray_bed", Res.drawable.gray_bed)
  map.put("gray_carpet", Res.drawable.gray_carpet)
  map.put("gray_concrete", Res.drawable.gray_concrete)
  map.put("gray_concrete_powder", Res.drawable.gray_concrete_powder)
  map.put("gray_dye", Res.drawable.gray_dye)
  map.put("gray_glazed_terracotta", Res.drawable.gray_glazed_terracotta)
  map.put("gray_shulker_box", Res.drawable.gray_shulker_box)
  map.put("gray_stained_glass", Res.drawable.gray_stained_glass)
  map.put("gray_stained_glass_pane", Res.drawable.gray_stained_glass_pane)
  map.put("gray_terracotta", Res.drawable.gray_terracotta)
}
